import React, { FC } from 'react';
import styled from 'styled-components';
import { ReactComponent as Logo } from '../../assets/svg/e_huquqshunos.svg';
import { Box, Typography } from '@mui/material';

const StyledLogo = styled.div`
    width: 50px;
    height: 50px;

    & svg {
        width: 100%;
        height: 100%;
    }
`;

const LogoIjro: FC = (): JSX.Element => {
  return (
    <div className="flex items-center gap-10">
      <StyledLogo>
        <Logo />
      </StyledLogo>
      <Box>
        <Typography fontSize="14" fontWeight="600" color="#20293A">
          E-Huquqshunos
        </Typography>
        <Typography fontSize="14" fontWeight="400" color="#677389">
          Электрон тизими
        </Typography>
      </Box>
    </div>
  );
};

export default LogoIjro;
